<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="6"
            :lg="6"
          >
          <Divider orientation="left">{{ langMap.resourceManagement[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="18"
            :lg="18"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.status[lang]"
                class="leftFlex"
              >
                <Select v-model.trim="status">
                  <Option value=0>{{ langMap.all[lang] }}</Option>
                  <Option value=1>{{ langMap.normal[lang] }}</Option>
                  <Option value=2>{{ langMap.disabled[lang] }}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.method[lang]"
                class="leftFlex"
              >
                <Select v-model.trim="method">
                  <Option value=''>{{ langMap.all[lang] }}</Option>
                  <Option value="GET">GET</Option>
                  <Option value="POST">POST</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.keyword[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="keyWord "
                  :placeholder="langMap.keyword[lang]"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{ langMap.search[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="resourcesCol"
        :data="resourcesList"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="resourcesList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>
  </div>

</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      resourcesList: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      keyWord: "",
      status: 0,
      method: ""
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    resourcesCol() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.application[this.lang],
          minWidth: 120,
          key: "application"
        },
        {
          title: langMap.name[this.lang],
          minWidth: 120,
          key: "name"
        },
        {
          title: langMap.route[this.lang],
          minWidth: 150,
          key: "url"
        },
        {
          title: langMap.method[this.lang],
          minWidth: 120,
          key: "method"
        },
        {
          title: langMap.status[this.lang],
          key: "status",
          width: 90,
          render: (h, params) => {
            var text = "";
            var color = "";
            if (params.row.status == 1) {
              text = langMap.normal[this.lang];
              color = "green";
            } else if (params.row.status == 2) {
              text = langMap.disabled[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.updateTime[this.lang],
          minWidth: 150,
          key: "updateTime",
          render: (h, params) => {
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModification[this.lang];
            }
            return h("span", text);
          }
        },

        {
          title: langMap.creator[this.lang],
          minWidth: 120,
          key: "createName",
          width: 90
        },
        {
          title: langMap.createTime[this.lang],
          minWidth: 150,
          key: "createTime"
        }
      ]
    }
  },
  methods: {
    //获取产品
    getList() {
      this.tableLoading = true;
      api
        .getData(
          "system-server/sys/resources/list?index=" +
            this.index +
            "&keyWord=" +
            this.keyWord +
            "&status=" +
            this.status +
            "&method=" +
            this.method,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tips[this.lang],
              desc: res.msg
            });
          } else {
            this.resourcesList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style>
</style>
